<div class="container-fluid py-4 h-100" style="background-color: #fafbfc; border-radius: 8px; box-shadow: 0 4px 6px rgba(0,0,0,0.02);">
  
  <div class="row align-items-center mb-4 pb-2 border-bottom">
    <div class="col">
      <h3 style="color: #286676; font-weight: 700; margin-bottom: 4px;">Cancellation Reasons</h3>
      <p class="text-muted" style="margin-bottom: 0; font-size: 0.95rem;">Manage the reasons available when cancelling a booking</p>
    </div>
    <div class="col text-end">
      <button class="btn px-4 shadow-sm fw-bold" style="background-color: #286676; color: white; border-radius: 6px; font-weight: 500; transition: all 0.2s ease;" (click)="openModal()" onmouseover="this.style.filter='brightness(1.1)'" onmouseout="this.style.filter='brightness(1)'">
        + Add Reason
      </button>
    </div>
  </div>

  <!-- Styled Tabs -->
  <ul class="nav nav-pills mb-4 gap-2 border-bottom pb-3">
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'Admin'}" (click)="setTab('Admin')" style="cursor:pointer; border-radius: 20px; padding: 8px 24px; font-weight: 500;" [style.backgroundColor]="activeTab === 'Admin' ? '#286676' : 'transparent'" [style.color]="activeTab === 'Admin' ? 'white' : '#6D6D6D'">
        Admin Reasons
      </a>
    </li>
    <li class="nav-item">
      <a class="nav-link" [ngClass]="{'active': activeTab === 'Tourist'}" (click)="setTab('Tourist')" style="cursor:pointer; border-radius: 20px; padding: 8px 24px; font-weight: 500;" [style.backgroundColor]="activeTab === 'Tourist' ? '#286676' : 'transparent'" [style.color]="activeTab === 'Tourist' ? 'white' : '#6D6D6D'">
        Tourist Reasons
      </a>
    </li>
  </ul>

  <!-- Loader -->
  <div class="text-center my-5 py-5" *ngIf="isLoading">
    <div class="spinner-border" style="color: #286676; width: 3rem; height: 3rem;" role="status">
      <span class="visually-hidden">Loading...</span>
    </div>
    <p class="mt-3 text-muted fw-medium">Loading reasons...</p>
  </div>

  <!-- Data Table -->
  <div class="table-responsive shadow-sm bg-white p-1 rounded-3" *ngIf="!isLoading" style="border: 1px solid #ebedf0;">
    <table class="table table-hover align-middle mb-0">
      <thead style="background-color: #f8f9fa;">
        <tr>
          <th style="padding: 16px; width: 5%; color: #495057; font-weight: 600; font-size: 0.9rem;" class="border-0">#</th>
          <th style="padding: 16px; color: #495057; font-weight: 600; font-size: 0.9rem;" class="border-0">Reason Text</th>
          <th style="padding: 16px; width: 15%; text-align: center; color: #495057; font-weight: 600; font-size: 0.9rem;" class="border-0">Actions</th>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngIf="activeTab === 'Admin'">
          <tr *ngFor="let item of adminReasons; let i = index" style="border-top: 1px solid #ebedf0;">
            <td style="padding: 16px; font-weight: 500; color: #6c757d;">{{i + 1}}</td>
            <td style="padding: 16px; color: #343a40; font-weight: 500;">{{item.reasonText}}</td>
            <td style="padding: 16px;" class="text-center">
              <button class="btn btn-sm btn-outline-primary mx-1" (click)="openModal(item)">
                Edit
              </button>
              <button class="btn btn-sm btn-outline-danger mx-1" (click)="deleteReason(item)">
                Delete
              </button>
            </td>
          </tr>
          <tr *ngIf="adminReasons.length === 0">
            <td colspan="3" class="text-center text-muted py-5">
              <p class="mb-0 fw-medium">No reasons found for Admin</p>
            </td>
          </tr>
        </ng-container>

        <ng-container *ngIf="activeTab === 'Tourist'">
          <tr *ngFor="let item of touristReasons; let i = index" style="border-top: 1px solid #ebedf0;">
            <td style="padding: 16px; font-weight: 500; color: #6c757d;">{{i + 1}}</td>
            <td style="padding: 16px; color: #343a40; font-weight: 500;">{{item.reasonText}}</td>
            <td style="padding: 16px;" class="text-center">
              <button class="btn btn-sm btn-outline-primary mx-1" (click)="openModal(item)">
                Edit
              </button>
              <button class="btn btn-sm btn-outline-danger mx-1" (click)="deleteReason(item)">
                Delete
              </button>
            </td>
          </tr>
          <tr *ngIf="touristReasons.length === 0">
            <td colspan="3" class="text-center text-muted py-5">
              <p class="mb-0 fw-medium">No reasons found for Tourist</p>
            </td>
          </tr>
        </ng-container>
      </tbody>
    </table>
  </div>
</div>

<!-- Add/Edit Modal overlay (using basic Angular if Bootstrap js isn't triggered) -->
<div class="modal fade show d-block" tabindex="-1" style="background: rgba(15, 30, 40, 0.6); backdrop-filter: blur(2px);" *ngIf="showModal">
  <div class="modal-dialog modal-dialog-centered shadow-lg">
    <div class="modal-content" style="border: none; border-radius: 12px; overflow: hidden;">
      <div class="modal-header text-white px-4 py-3" style="background: linear-gradient(135deg, #286676 0%, #1e4d58 100%);">
        <h5 class="modal-title fw-bold m-0">{{ isEditing ? 'Edit' : 'Add' }} Cancellation Reason</h5>
        <button type="button" class="btn-close btn-close-white shadow-none" (click)="closeModal()" aria-label="Close"></button>
      </div>
      <div class="modal-body p-4 bg-light">
        <form [formGroup]="reasonForm">
          <div class="mb-4">
            <label class="form-label fw-semibold text-secondary" style="font-size: 0.9rem;">Target Audience (Reason For)</label>
            <div class="input-group drop-shadow-sm">
              <select class="form-select ps-3" formControlName="reasonFor" [attr.disabled]="isEditing ? true : null" style="background-color: white;">
                <option value="Admin">Admin</option>
                <option value="Tourist">Tourist</option>
              </select>
            </div>
            <small *ngIf="isEditing" class="text-muted mt-1 d-block">You cannot change the audience while editing.</small>
          </div>
          
          <div class="mb-3">
            <label class="form-label fw-semibold text-secondary" style="font-size: 0.9rem;">Reason Description</label>
            <textarea class="form-control drop-shadow-sm" formControlName="reasonText" rows="4" placeholder="Enter the cancellation reason in detail..." style="resize: none; border-radius: 8px;"></textarea>
            <div *ngIf="reasonForm.get('reasonText')?.invalid && reasonForm.get('reasonText')?.touched" class="text-danger mt-2 small fw-medium">
              Reason text is required.
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer px-4 py-3 bg-white border-top">
        <button type="button" class="btn btn-light border px-4 shadow-sm" (click)="closeModal()">Cancel</button>
        <button type="button" class="btn px-4 shadow-sm text-white" style="background-color: #286676;" [disabled]="reasonForm.invalid" (click)="submitReason()">
          {{ isEditing ? 'Save Changes' : 'Add Reason' }}
        </button>
      </div>
    </div>
  </div>
</div>
